import { Picture, Modal } from '@ui';
import { observer } from 'mobx-react';
import icons from '@icons';
import './index.scss';
import type { FC } from 'react';

const {
  info: { black: infoBlackFilled }
} = icons.Fill;

interface ReviewRulesModalProps {
  onClose: () => void;
}

const ReviewRulesModal: FC<ReviewRulesModalProps> = observer(({ onClose }) => (
  <Modal
    framed
    onClose={onClose}
    size='max-w-[723px]'
    placementMobile='fullscreen'
  >
    <div className='review-rules-modal__content'>
      <div className='review-rules-modal__heading'>
        Правила оформления <br /> отзывов и вопросов
      </div>
      <div className='review-rules-modal__disc'>
        <Picture icon={infoBlackFilled} height='24' width='24' />
        Администрация сайта оставляет за собой право не публиковать отзывы
        по&nbsp;следующим критериям:
      </div>
      <div className='review-rules-modal__info'>
        <ol>
          <li>
            Отзывы, которые содержат упоминания других магазинов, рынков,
            производителей, поставщиков или наименования аналогичных товаров,
            ссылки на сторонние ресурсы
          </li>
          <li>Отзывы, которые содержат нецензурные выражения и оскорбления.</li>
          <li>
            Обращения в адрес магазина по вопросам, не имеющим отношения к
            свойствам конкретного товара (о работе магазина, сайта и т.д.)
          </li>
          <li>
            <ul>
              Отзывы или жалобы, не содержащие полезных сведений о свойствах
              товара:
              <li>
                жалобы на поврежденную упаковку, размороженный или поврежденный
                при транспортировке товар и т.п. В каждом случае вопрос решается
                с покупателем.
              </li>
              <li>
                субъективные мнения о ценах и других характеристиках товара от
                тех, кто его не покупал.
              </li>
              <li>неинформативные отзывы без обоснования оценки.</li>
            </ul>
          </li>
          <li>
            Вопросы о сроках годности, производителе товара, повторяющиеся
            вопросы, ответы на которые были опубликованы ранее.
          </li>
          <li>
            Жалобы на товары, по которым не соблюдались условия хранения или
            истекли сроки годности на момент написания отзыва.
          </li>
        </ol>
      </div>
    </div>
  </Modal>
));

export default ReviewRulesModal;
